"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SHARED_EVENTS;
(function (SHARED_EVENTS) {
    SHARED_EVENTS["CART_VIEWED"] = "Cart Viewed";
    SHARED_EVENTS["FISHING_REPORT_VIEWED"] = "Fishing Report Viewed";
    SHARED_EVENTS["PRODUCT_VIEWED"] = "Product Viewed";
})(SHARED_EVENTS || (SHARED_EVENTS = {}));
var WEB_SPECIFIC_EVENTS;
(function (WEB_SPECIFIC_EVENTS) {
    WEB_SPECIFIC_EVENTS["ADD_TO_CART"] = "Add to Cart";
    WEB_SPECIFIC_EVENTS["AMBASSADOR_APPLICATION_STEP"] = "Ambassador Application Step";
    WEB_SPECIFIC_EVENTS["ARTICLES_MODAL_OPENED"] = "Articles Modal Opened";
    WEB_SPECIFIC_EVENTS["CART_CLICK"] = "Cart Click";
    WEB_SPECIFIC_EVENTS["CART_DEAL_ADDED"] = "Cart Deal Added";
    WEB_SPECIFIC_EVENTS["CART_PROMO_CODE_ADDED"] = "Cart Promo Code Added";
    WEB_SPECIFIC_EVENTS["CART_PROMO_CODE_REMOVED"] = "Cart Promo Code Removed";
    WEB_SPECIFIC_EVENTS["CART_REWARDS_ADDED"] = "Cart Rewards Added";
    WEB_SPECIFIC_EVENTS["CART_REWARDS_REMOVED"] = "Cart Rewards Removed";
    WEB_SPECIFIC_EVENTS["CART_VIEWED"] = "Cart Viewed";
    WEB_SPECIFIC_EVENTS["CONTENT_FILTERED"] = "Content Filtered";
    WEB_SPECIFIC_EVENTS["DYNAMIC_SEO_PAGE_CLICK"] = "Dynamic SEO Page Click";
    WEB_SPECIFIC_EVENTS["FISHING_REPORT_COMPLETED"] = "Fishing Report Completed";
    WEB_SPECIFIC_EVENTS["FISHING_REPORT_DETAILS_CLICK"] = "Fishing Report Details Click";
    WEB_SPECIFIC_EVENTS["FISHING_REPORT_EMBEDDED_CLICK"] = "Fishing Report Embedded Click";
    WEB_SPECIFIC_EVENTS["FISDHING_REPORT_LIST_VIEWED"] = "Fishing Report List Viewed";
    WEB_SPECIFIC_EVENTS["FISHING_REPORT_STARTED"] = "Fishing Report Started";
    WEB_SPECIFIC_EVENTS["FOOTER_NAV_CLICK"] = "Footer Nav Click";
    WEB_SPECIFIC_EVENTS["GET_STARTED_FORM_STATUS"] = "Get Started Form Status";
    WEB_SPECIFIC_EVENTS["GET_STARTED_PAGE_CLICK"] = "Get Started Page Click";
    WEB_SPECIFIC_EVENTS["GET_STARTED_SAVE_PREFERENCES"] = "Get Started Save Preferences";
    WEB_SPECIFIC_EVENTS["GET_STARTED_SHARE"] = "Get Started Share";
    WEB_SPECIFIC_EVENTS["HOMEPAGE_AD_CLICK"] = "Homepage Ad Click";
    WEB_SPECIFIC_EVENTS["HOMEPAGE_CONTENT_CLICK"] = "Homepage Content Click";
    WEB_SPECIFIC_EVENTS["HOMEPAGE_PRODUCT_CLICK"] = "Homepage Product Click";
    WEB_SPECIFIC_EVENTS["HOMEPAGE_WATERBODY_CLICK"] = "Homepage Waterbody Click";
    WEB_SPECIFIC_EVENTS["ITEM_FAVORITED"] = "Item Favorited";
    WEB_SPECIFIC_EVENTS["LAKE_PAGE_CLICK"] = "Lake Page Click";
    WEB_SPECIFIC_EVENTS["MAP_CLICK"] = "Map Click";
    WEB_SPECIFIC_EVENTS["OUT_OF_STOCK_NOTIFIED"] = "Out of Stock Notified";
    WEB_SPECIFIC_EVENTS["PRODUCT_ADDED"] = "Product Added";
    WEB_SPECIFIC_EVENTS["PRODUCT_ADDED_TO_WISHLIST"] = "Product Added to Wishlist";
    WEB_SPECIFIC_EVENTS["PRODUCT_CARD_CLICKED"] = "Product Card Clicked";
    WEB_SPECIFIC_EVENTS["PRODUCT_CATEGORY_FILTERED"] = "Product Category Filtered";
    WEB_SPECIFIC_EVENTS["PRODUCT_CLICK"] = "Product Click";
    WEB_SPECIFIC_EVENTS["PRODUCT_DETAILS_PAGE_CLICK"] = "Product Details Page Click";
    WEB_SPECIFIC_EVENTS["PRODUCT_LIST_VIEWED"] = "Product List Viewed";
    WEB_SPECIFIC_EVENTS["PRODUCT_REMOVED"] = "Product Removed";
    WEB_SPECIFIC_EVENTS["PROMO_BAR_CLICK"] = "Promo Bar Click";
    WEB_SPECIFIC_EVENTS["SCROLL_TO_TOP_CLICK"] = "Scroll to Top Click";
    WEB_SPECIFIC_EVENTS["SEARCH_FILTER_CLICK"] = "Search Filter Click";
    WEB_SPECIFIC_EVENTS["SEARCH_RESULT_CLICK"] = "Search Result Click";
    WEB_SPECIFIC_EVENTS["SHOPPABLE_VIDEO_ITEM_CLICK"] = "Shoppable Video Item Click";
    WEB_SPECIFIC_EVENTS["SHOPPABLE_VIDEO_PLAYBACK_STATUS"] = "Shoppable Video Playback Status";
    WEB_SPECIFIC_EVENTS["SHORT_LINK_CLICK"] = "Short Link Click";
    WEB_SPECIFIC_EVENTS["SOCIAL_SHARE"] = "Social Share";
    WEB_SPECIFIC_EVENTS["TOP_NAV_CLICK"] = "Top Nav Click";
    WEB_SPECIFIC_EVENTS["WISHLIST_ITEM_CLICK"] = "Wishlist Item Click";
    WEB_SPECIFIC_EVENTS["WISHLIST_SHARE"] = "Wishlist Share";
})(WEB_SPECIFIC_EVENTS || (WEB_SPECIFIC_EVENTS = {}));
var APP_SPECIFIC_EVENTS;
(function (APP_SPECIFIC_EVENTS) {
    APP_SPECIFIC_EVENTS["FISHING_REPORT_VIEWED"] = "Fishing Report Viewed";
    APP_SPECIFIC_EVENTS["LOCATION_OPT_IN"] = "Location Services Opt-In";
    APP_SPECIFIC_EVENTS["NOTIFICATION_OPT_IN"] = "Push Notification Opt-In";
    APP_SPECIFIC_EVENTS["SHOP_SUBSCREEN_VIEWED"] = "Shop Sub Screen Viewed";
})(APP_SPECIFIC_EVENTS || (APP_SPECIFIC_EVENTS = {}));
const APP_TRACKING_EVENTS = { ...APP_SPECIFIC_EVENTS, ...SHARED_EVENTS };
const WEB_TRACKING_EVENTS = { ...WEB_SPECIFIC_EVENTS, ...SHARED_EVENTS };
